import { useInfiniteQuery } from "@tanstack/react-query";
import { useCallback, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import debounce from "lodash.debounce";
import { fetchBankAccountDetails, fetchDailyJournal, fetchJvBankAccountByClient, fetchJvPaymentsByClientId, fetchReadJvBroker } from "../../utils/apiUtils";
import SharedTable from "../benefitPlan/SharedTable";
import Select from 'react-select';
import { loadClients, loadJVBrokerss } from "../../utils/optionLoaderUtils";
import { AsyncPaginate } from "react-select-async-paginate";
import { customStyles } from "../../utils/styleUtils";

const searchEntryTypeOptions = [
    { label: 'O', value: 'O' },
    { label: 'C', value: 'C' },
    { label: 'X', value: 'X' },
    { label: 'Z', value: 'Z' }
]

const DailyCheckJournal = () => {

    const [searchValue, setSearchValue] = useState();
    const [decouncedSearchValue, setDecouncedSearchValue] = useState();
    const [selectedEntryTypeSearchOption, setSelectedEntryTypeSearchOption] = useState(null);
    const [selectedClient, setSelectedClient] = useState()
    const [selectedBroker, setSelectedBroker] = useState()
    const [showMoreColumns, setShowMoreColumns] = useState(false);


    const { ref, inView } = useInView();

    const { data, error, fetchNextPage, hasNextPage, isLoading, isPending, isFetching, isFetchingNextPage, status, refetch } = useInfiniteQuery({
        queryKey: ["jv-daily-check-journal", decouncedSearchValue, selectedEntryTypeSearchOption, selectedClient, selectedBroker],
        queryFn: async ({ pageParam }) => {
            let params = pageParam || {};

            if (decouncedSearchValue) {
                params.clientId = decouncedSearchValue
            }

            if (selectedEntryTypeSearchOption?.value) {
                params.entryType = selectedEntryTypeSearchOption?.value
            }

            if (selectedClient) {
                params.clientId = selectedClient.value
            }

            if (selectedBroker) {
                params.payeeId = selectedBroker.value
            }

            return await fetchDailyJournal({ ...params });
        },

        select: (data) => {
            const flattenRows = data.pages.flatMap((x) => x.rows).filter(x => Object.keys(x)?.length)
            return {
                total: data.pages?.[0]?.total,
                rows: flattenRows

            };
        },
        initialPageParam: 0,
        getNextPageParam: (lastPage, pages) => {
            console.log({ lastPage })
            const hasMore = lastPage?.rows?.length < lastPage?.total

            if (!hasMore) return undefined;
            return { offset: pages.reduce((acc, curr) => acc + curr.rows.length, 0) }
        },
        staleTime: 0,//12 * 60 * 60 * 1000, //12 hours
        enabled: true,
    });

    useEffect(() => {
        if (inView) {
            fetchNextPage();
        }
    }, [inView]);

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchValue(event.target.value?.trim());
        }, 500),
        []
    );

    let columns = ['account_id', 'checknumber', 'checkissuedate', 'payeeamount', 'payto', 'payeename', 'broker_name', 'employeeid', 'dependentsequencenumber', 'paymentmethod', 'status', 'changedby', 'changeddate'];


    if (showMoreColumns) {
        // columns = [
        //     'memberKey',
        //     ...columns,

        // ];
        if (data?.rows) {
            const fistRow = data?.rows?.[0]

            columns = [
                ...Object.keys(fistRow).sort(),
            ];
        }
    }

    const onDetailHandler = async (body) => {

        // const [bankAcctByClient, brokerInfo] = await Promise.allSettled([
        //     fetchJvBankAccountByClient({ clientId: body.clientid }),
        //     fetchReadJvBroker({ code: body.clientid })
        // ])
        // console.log({ body })
        if (!body?.client_id) return {}
        const bankAcctByClient = await fetchBankAccountDetails({ pk: body.client_id, sk: 'bankInfo' })

        return {
            bankInfo: bankAcctByClient?.Items?.[0],
            // brokerInfo: brokerInfo?.value?.Response?.BrokerDemographic
        }
    }

    return (
        <div className={'container '}>
            <p className='title'>Payments</p>
            <p className="sub-title">JV payments {data?.total}</p>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1rem 1rem 0rem', }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: '100%', flexWrap: 'wrap', }}>

                    <AsyncPaginate

                        placeholder={`Client Id`}
                        className="react-select-container large-input"
                        classNamePrefix={"react-select"}
                        debounceTimeout={300}
                        value={selectedClient}
                        //  cacheUniqs={[i]}
                        clearCacheOnMenuClose={true}
                        clearCacheOnSearchChange={true}
                        isSearchable={true}
                        loadOptions={loadClients} //{i ? loadAccounts : loadAccountHccIdentificationNumber}
                        onChange={v => setSelectedClient(v)}

                        styles={customStyles}
                        isClearable={true}
                    />

                    <AsyncPaginate

                        placeholder={`Payee | Broker`}
                        className="react-select-container large-input"
                        classNamePrefix={"react-select"}
                        debounceTimeout={300}
                        value={selectedBroker}
                        //  cacheUniqs={[i]}
                        clearCacheOnMenuClose={true}
                        clearCacheOnSearchChange={true}
                        isSearchable={true}
                        loadOptions={loadJVBrokerss} //{i ? loadAccounts : loadAccountHccIdentificationNumber}
                        onChange={v => setSelectedBroker(v)}

                        styles={customStyles}
                        isClearable={true}
                    />

                    {/* <input
                        style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                        type="text"
                        id={"search"}
                        placeholder="Client Id..."
                        // list="items"
                        autoComplete="off"
                        // onFocus={() => setCurrentPage(0)}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            debouncedChangeHandler(e);
                        }}
                        value={searchValue}
                    /> */}

                    {/* <Select
                        name={'searchOptions'}
                        placeholder="Entry type"
                        className="react-select-container large-input"
                        classNamePrefix="react-select"
                        options={searchEntryTypeOptions}
                        value={selectedEntryTypeSearchOption}
                        onChange={(option) => { setSelectedEntryTypeSearchOption(option) }}
                    /> */}

                </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0rem 1rem 1rem 0rem", }}>
                <p
                    style={{ cursor: "pointer", color: "var(--red)" }}
                    onClick={() => {
                        setSelectedClient(null)
                        setSelectedEntryTypeSearchOption(null)
                        setSelectedBroker(null)
                        setDecouncedSearchValue("");
                        setSearchValue("");
                    }}
                >
                    Clear filters
                </p>

                <p style={{ cursor: "pointer", color: "var(--green)" }} onClick={() => setShowMoreColumns(!showMoreColumns)}>
                    {showMoreColumns ? "Less Columns" : "More Columns"}
                </p>

            </div>


            {status === "loading" ? (
                <p>Loading...</p>
            ) : status === "error" ? (
                <span className='danger'>Error: {error.message}</span>
            ) : (
                <>
                    <SharedTable
                        type={"jv-check-payments"}
                        disableHeaderFormatting={true}
                        columns={columns}
                        items={data?.rows}
                        activeDraftId={null}
                        hasNextPage={hasNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        fetchNextPage={fetchNextPage}
                        isFetching={isFetching}
                        isLoading={isLoading}
                        // onEditHandler={onEditHandler}
                        onDetailHandler={onDetailHandler}
                        sortModalJsonKeys={false}
                        ref={ref}
                    />
                </>
            )}

        </div>
    )
}

export default DailyCheckJournal